<div class="tw-border tw-border-solid tw-border-geyser tw-bg-white tw-p-8">
  <div class="tw-flex tw-flex-col">
    <p
      class="prose-p:tw-mt-5 prose-p:tw-font-sans prose-strong:tw-font-sans prose-strong:tw-font-semibold prose-ul:tw-ml-5 prose-ul:tw-list-disc prose-ul:tw-font-sans"
      [innerHTML]="'screens.deceasedInformation.introduction.part1' | translate"
    ></p>
    <div class="tw-mt-9 tw-flex tw-items-center">
      <ia-icons name="information_white" class="tw-size-6 tw-shrink-0" color="#a33467" />
      <p
        class="prose-p:tw-ml-2 prose-p:tw-font-sans prose-p:tw-font-semibold prose-p:tw-text-magenta-haze"
        [innerHTML]="'screens.deceasedInformation.introduction.part2' | translate"
      ></p>
    </div>
    <p
      class="tw-mt-5 prose-p:tw-mt-5 prose-p:tw-font-sans prose-strong:tw-mt-5 prose-strong:tw-font-sans prose-strong:tw-font-semibold"
      [innerHTML]="'screens.deceasedInformation.introduction.part3' | translate"
    ></p>
    <p
      class="tw-pt-3 tw-font-sans tw-text-sm tw-text-gray prose-a:tw-text-sea-green prose-a:tw-underline"
      [innerHTML]="'screens.deceasedInformation.introduction.legalNotice' | translate"
    ></p>
  </div>
</div>
<p
  class="tw-mt-5 tw-px-5 tw-pb-0.5 tw-font-sans tw-text-sm tw-text-eerie-black sm:tw-mt-10 sm:tw-px-0 sm:tw-text-base"
>
  {{ 'screens.deceasedInformation.requiredFields' | translate }}
</p>
<form
  class="tw-pt-7"
  (ngSubmit)="deceasedInformationFacade.onNext()"
  [formGroup]="deceasedInformationFacade.deceasedInformationForm"
  iaInvalidControlScroll
>
  <ia-panel class="tw-mt-4 tw-block">
    <div header class="">
      <span class="tw-pl-3 tw-text-lg tw-font-semibold tw-text-eerie-black">{{
        'screens.deceasedInformation.information.title' | translate
      }}</span>
    </div>
    <div content class="tw-px-8 tw-pb-6 tw-pt-5">
      <p class="tw-font-sans tw-text-sm sm:tw-text-base">
        {{ 'screens.deceasedInformation.information.description' | translate }}
      </p>

      <div class="tw-mt-3 tw-flex tw-flex-col">
        <p class="tw-pt-3 tw-font-sans tw-font-semibold" id="label-deceased-information-civility">
          {{ 'screens.deceasedInformation.information.civility.label' | translate }}
        </p>
        @for (object of successionFacade.listBoxItems.gender; track object; let index = $index) {
          <ia-radio-button
            aria-describedby="gender"
            class="first-letter:tw-uppercase"
            type="radio"
            [value]="object.value"
            groupName="gender"
            formControlName="gender"
          >
            {{ object.label }}
          </ia-radio-button>
        }
        @if (deceasedInformationFacade.gender.touched && deceasedInformationFacade.gender.invalid) {
          <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
            {{ 'screens.deceasedInformation.information.civility.error' | translate }}
          </p>
        }
      </div>

      <div class="tw-mt-7.5 tw-flex tw-flex-col">
        <label
          class="tw-font-sans tw-text-base tw-font-semibold"
          id="label-deceased-information-last-name"
          for="input-deceased-information-last-name"
          >{{ 'screens.deceasedInformation.information.lastName.label' | translate }}</label
        >
        <input
          [error]="deceasedInformationFacade.name.touched && deceasedInformationFacade.name.invalid"
          [patterns]="successionFacade.numbersAndSpecialCharactersNotAllowed"
          class="tw-w-full md:tw-w-1/2"
          formControlName="name"
          iaInput
          id="input-deceased-information-last-name"
          data-test-id="input-deceased-information-last-name"
          mask="A*"
          [specialCharacters]="[' -', 'space']"
          maxlength="32"
          name="name"
        />
        @if (deceasedInformationFacade.name.touched && deceasedInformationFacade.name.invalid) {
          <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
            {{ 'screens.deceasedInformation.information.lastName.error' | translate }}
          </p>
        }
      </div>

      <div class="tw-mt-7.5 tw-flex tw-flex-col">
        <label
          class="tw-font-sans tw-text-base tw-font-semibold"
          for="input-deceased-information-birth-name"
          id="label-deceased-information-birth-name"
          >{{ 'screens.deceasedInformation.information.birthName' | translate }}
        </label>
        <input
          [patterns]="successionFacade.numbersAndSpecialCharactersNotAllowed"
          class="tw-w-full md:tw-w-1/2"
          formControlName="birthname"
          iaInput
          id="input-deceased-information-birth-name"
          data-test-id="input-deceased-information-birth-name"
          mask="A*"
          [specialCharacters]="[' -', 'space']"
          maxlength="32"
          name="birthname"
        />
      </div>

      <div class="tw-mt-7.5 tw-flex tw-flex-col">
        <label
          class="tw-font-sans tw-text-base tw-font-semibold"
          for="input-deceased-information-first-name"
          id="label-deceased-information-first-name"
          >{{ 'screens.deceasedInformation.information.firstName.label' | translate }}</label
        >
        <input
          [error]="
            deceasedInformationFacade.firstname.touched &&
            deceasedInformationFacade.firstname.invalid
          "
          [patterns]="successionFacade.numbersAndSpecialCharactersNotAllowed"
          #anchors
          class="tw-w-full md:tw-w-1/2"
          formControlName="firstname"
          iaInput
          id="input-deceased-information-first-name"
          data-test-id="input-deceased-information-first-name"
          mask="A*"
          [specialCharacters]="[' -', 'space']"
          maxlength="32"
          name="firstname"
        />
        @if (
          deceasedInformationFacade.firstname.touched && deceasedInformationFacade.firstname.invalid
        ) {
          <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
            {{ 'screens.deceasedInformation.information.firstName.error' | translate }}
          </p>
        }
      </div>

      <div class="tw-mt-7.5 tw-flex tw-flex-col">
        <label
          class="tw-font-sans tw-text-base tw-font-semibold"
          for="input-deceased-information-birth-date"
          id="label-deceased-information-birth-date"
          >{{ 'screens.deceasedInformation.information.birthDate.label' | translate }}</label
        >
        <div class="tw-w-full md:tw-w-1/2">
          <ia-datepicker
            autocomplete="off"
            formControlName="dateOfBirth"
            [placeholder]="'JJ/MM/AAAA'"
            [locale]="'fr'"
            [maxDate]="successionFacade.today"
            id="input-deceased-information-birth-date"
            [inputConfig]="{
              containerClass:
                'ia-datepicker' +
                (deceasedInformationFacade.dateOfBirth.touched &&
                deceasedInformationFacade.dateOfBirth.invalid
                  ? ' !tw-border-imperial-red'
                  : ''),
            }"
          />
        </div>
        @if (
          deceasedInformationFacade.dateOfBirth.touched &&
          deceasedInformationFacade.dateOfBirth.invalid
        ) {
          <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
            {{ 'screens.deceasedInformation.information.birthDate.error' | translate }}
          </p>
        }
      </div>

      <div class="tw-mt-7.5 tw-flex tw-flex-col">
        <label
          class="tw-font-sans tw-text-base tw-font-semibold"
          id="label-deceased-information-birth-country"
          for="input-deceased-information-country-of-birth"
          >{{ 'screens.deceasedInformation.information.birthCountry.label' | translate }}</label
        >
        <ia-listbox2
          formControlName="countryOfBirth"
          [overlayOverrides]="listBoxOverlayConfig"
          class="tw-mt-2.5 tw-w-full md:tw-w-1/2"
          triggerId="input-deceased-information-country-of-birth"
          triggerAriaLabelledBy="label-deceased-information-birth-country"
        >
          <div *iaListbox2Placeholder>
            {{ 'screens.deceasedInformation.information.birthCountry.placeholder' | translate }}
          </div>

          @for (option of successionFacade.listBoxItems.countries; track option.value) {
            <ia-listbox2-option [value]="option.value">
              {{ option.label }}
            </ia-listbox2-option>
          }
        </ia-listbox2>
        @if (
          deceasedInformationFacade.countryOfBirth.touched &&
          deceasedInformationFacade.countryOfBirth.invalid
        ) {
          <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
            {{ 'screens.deceasedInformation.information.birthCountry.error' | translate }}
          </p>
        }
      </div>

      <div class="tw-mt-7.5 tw-flex tw-flex-col">
        <div class="tw-flex-row">
          <label
            class="tw-font-sans tw-text-base tw-font-semibold"
            for="input-deceased-information-birth-department"
            id="label-deceased-information-birth-department"
            >{{
              'screens.deceasedInformation.information.birthDepartment.label' | translate
            }}</label
          >
          @if (deceasedInformationFacade.countryOfBirth.value !== countryFrance) {
            <span class="tw-font-sans tw-text-base tw-font-semibold">
              {{ 'screens.deceasedInformation.information.optional' | translate }}</span
            >
          }
        </div>
        <input
          [error]="
            deceasedInformationFacade.departmentOfBirth.touched &&
            deceasedInformationFacade.departmentOfBirth.invalid
          "
          [mask]="deceasedInformationFacade.countryOfBirth.value === countryFrance ? 'AA' : 'B*'"
          [patterns]="numbersOnlyOrSpecialCharactersNotAllowed"
          iaInput
          class="tw-w-full md:tw-w-1/2"
          formControlName="departmentOfBirth"
          id="input-deceased-information-birth-department"
          data-test-id="input-deceased-information-birth-department"
          maxlength="32"
          name="departmentOfBirth"
          type="text"
        />
        @if (
          deceasedInformationFacade.departmentOfBirth.touched &&
          deceasedInformationFacade.departmentOfBirth.invalid
        ) {
          <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
            {{ 'screens.deceasedInformation.information.birthDepartment.error' | translate }}
          </p>
        }
      </div>

      <div class="tw-mt-7.5 tw-flex tw-flex-col">
        <div class="tw-flex-row">
          <label
            class="tw-font-sans tw-text-base tw-font-semibold"
            for="input-deceased-information-birth-place"
            id="label-deceased-information-birth-place"
            >{{ 'screens.deceasedInformation.information.birthPlace.label' | translate }}</label
          >
          @if (deceasedInformationFacade.countryOfBirth.value !== countryFrance) {
            <span class="tw-font-sans tw-text-base tw-font-semibold">
              {{ 'screens.deceasedInformation.information.optional' | translate }}</span
            >
          }
        </div>
        <input
          [error]="
            deceasedInformationFacade.communeOfBirth.touched &&
            deceasedInformationFacade.communeOfBirth.invalid
          "
          [patterns]="successionFacade.numbersAndSpecialCharactersNotAllowed"
          iaInput
          class="tw-w-full md:tw-w-1/2"
          formControlName="communeOfBirth"
          id="input-deceased-information-birth-place"
          data-test-id="input-deceased-information-birth-place"
          mask="A*"
          [specialCharacters]="[' -', 'space']"
          maxlength="32"
          name="communeOfBirth"
        />
        @if (
          deceasedInformationFacade.communeOfBirth.touched &&
          deceasedInformationFacade.communeOfBirth.invalid
        ) {
          <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
            {{ 'screens.deceasedInformation.information.birthPlace.error' | translate }}
          </p>
        }
      </div>

      <div class="tw-mt-7.5 tw-flex tw-flex-col">
        <label
          class="tw-font-sans tw-text-base tw-font-semibold"
          id="label-deceased-information-country"
          for="input-deceased-information-country"
          >{{ 'screens.deceasedInformation.information.country.label' | translate }}</label
        >
        <ia-listbox2
          formControlName="country"
          [overlayOverrides]="listBoxOverlayConfig"
          class="tw-mt-2.5 tw-w-full md:tw-w-1/2"
          triggerId="input-deceased-information-country"
          triggerAriaLabelledBy="label-deceased-information-country"
        >
          <div *iaListbox2Placeholder>
            {{ 'screens.deceasedInformation.information.country.placeholder' | translate }}
          </div>

          @for (option of successionFacade.listBoxItems.countries; track option.value) {
            <ia-listbox2-option [value]="option.value">
              {{ option.label }}
            </ia-listbox2-option>
          }
        </ia-listbox2>
        @if (
          deceasedInformationFacade.country.touched && deceasedInformationFacade.country.invalid
        ) {
          <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
            {{ 'screens.deceasedInformation.information.country.error' | translate }}
          </p>
        }
      </div>

      <div class="tw-mt-7.5 tw-flex tw-flex-col">
        <label
          class="tw-font-sans tw-text-base tw-font-semibold"
          id="label-deceased-information-postal-address"
          for="input-deceased-information-postal-address"
          >{{ 'screens.deceasedInformation.information.postalAddress.label' | translate }}</label
        >
        <input
          [error]="
            deceasedInformationFacade.address.touched && deceasedInformationFacade.address.invalid
          "
          [patterns]="successionFacade.specialCharactersNotAllowed"
          iaInput
          class="tw-w-full md:tw-w-1/2"
          formControlName="address"
          id="input-deceased-information-postal-address"
          data-test-id="input-deceased-information-postal-address"
          mask="A*"
          [specialCharacters]="[' -', 'space']"
          maxlength="38"
          name="address"
        />
        @if (
          deceasedInformationFacade.address.touched && deceasedInformationFacade.address.invalid
        ) {
          <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
            {{ 'screens.deceasedInformation.information.postalAddress.error' | translate }}
          </p>
        }
      </div>

      <div class="tw-mt-7.5 tw-flex tw-flex-col">
        <label
          class="tw-font-sans tw-text-base tw-font-semibold"
          for="input-deceased-information-additional-address"
          id="label-deceased-information-additional-address"
          >{{ 'screens.deceasedInformation.information.complementaryAddress' | translate }}</label
        >
        <input
          [patterns]="successionFacade.specialCharactersNotAllowed"
          iaInput
          class="tw-w-full md:tw-w-1/2"
          formControlName="complementaryAddress"
          id="input-deceased-information-additional-address"
          data-test-id="input-deceased-information-additional-address"
          mask="A*"
          [specialCharacters]="[' -', 'space']"
          maxlength="38"
          name="complementaryAddress"
        />
      </div>

      <div class="tw-mt-7.5 tw-flex tw-flex-col">
        <div class="tw-flex-row">
          <label
            class="tw-font-sans tw-text-base tw-font-semibold"
            for="input-deceased-information-postal-code"
            id="label-deceased-information-postal-code"
            >{{ 'screens.deceasedInformation.information.postalCode.label' | translate }}</label
          >
          @if (deceasedInformationFacade.country.value !== countryFrance) {
            <span class="tw-font-sans tw-text-base tw-font-semibold">
              {{ 'screens.deceasedInformation.information.optional' | translate }}</span
            >
          }
        </div>
        <input
          [error]="
            deceasedInformationFacade.zipcode.touched && deceasedInformationFacade.zipcode.invalid
          "
          [mask]="deceasedInformationFacade.country.value === countryFrance ? 'AAAAA' : 'A*'"
          [patterns]="successionFacade.specialCharactersNotAllowed"
          iaInput
          class="tw-w-full md:tw-w-1/2"
          formControlName="zipcode"
          id="input-deceased-information-postal-code"
          data-test-id="input-deceased-information-postal-code"
          maxlength="32"
          name="zipcode"
        />
        @if (
          deceasedInformationFacade.zipcode.touched && deceasedInformationFacade.zipcode.invalid
        ) {
          <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
            {{ 'screens.deceasedInformation.information.postalCode.error' | translate }}
          </p>
        }
      </div>

      <div class="tw-mt-7.5 tw-flex tw-flex-col">
        <div class="tw-flex-row">
          <label
            class="tw-font-sans tw-text-base tw-font-semibold"
            id="label-deceased-information-commune"
            for="input-deceased-information-commune"
            >{{ 'screens.deceasedInformation.information.commune.label' | translate }}</label
          >
          @if (deceasedInformationFacade.country.value !== countryFrance) {
            <span class="tw-font-sans tw-text-base tw-font-semibold">
              {{ 'screens.deceasedInformation.information.optional' | translate }}</span
            >
          }
        </div>
        <input
          [error]="deceasedInformationFacade.city.touched && deceasedInformationFacade.city.invalid"
          [patterns]="successionFacade.numbersAndSpecialCharactersNotAllowed"
          iaInput
          class="tw-w-full md:tw-w-1/2"
          formControlName="city"
          id="input-deceased-information-commune"
          data-test-id="input-deceased-information-commune"
          mask="A*"
          [specialCharacters]="[' -', 'space']"
          maxlength="32"
          name="city"
        />
        @if (deceasedInformationFacade.city.touched && deceasedInformationFacade.city.invalid) {
          <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
            {{ 'screens.deceasedInformation.information.commune.error' | translate }}
          </p>
        }
      </div>

      <div class="tw-mt-7.5 tw-flex tw-flex-col">
        <label
          class="tw-font-sans tw-text-base tw-font-semibold"
          id="label-deceased-information-marital-status"
          for="input-deceased-information-marital-status"
          >{{ 'screens.deceasedInformation.information.maritalStatus.label' | translate }}</label
        >
        <ia-listbox2
          formControlName="maritalStatus"
          [overlayOverrides]="listBoxOverlayConfig"
          class="tw-mt-2.5 tw-w-full md:tw-w-1/2"
          triggerId="input-deceased-information-marital-status"
          triggerAriaLabelledBy="label-deceased-information-marital-status"
        >
          <div *iaListbox2Placeholder>
            {{ 'screens.deceasedInformation.information.maritalStatus.placeholder' | translate }}
          </div>

          @for (option of successionFacade.listBoxItems.maritalStatus; track option.value) {
            <ia-listbox2-option [value]="option.value">
              {{ option.label }}
            </ia-listbox2-option>
          }
        </ia-listbox2>
        @if (
          deceasedInformationFacade.maritalStatus.touched &&
          deceasedInformationFacade.maritalStatus.invalid
        ) {
          <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
            {{ 'screens.deceasedInformation.information.maritalStatus.error' | translate }}
          </p>
        }
      </div>

      <div class="tw-mt-7.5 tw-flex tw-flex-col">
        <label
          class="tw-font-sans tw-text-base tw-font-semibold"
          id="label-deceased-information-iban"
          for="input-deceased-information-iban"
          >{{ 'screens.deceasedInformation.information.iban.label' | translate }}</label
        >
        <div class="tw-mt-3 tw-flex">
          <ia-iban-input formControlName="iban" id="input-deceased-information-iban" />
          <ia-tooltip [position]="'bottom'" colorClass="" class="tw-pt-3">
            <div class="tw-flex tw-w-[250px] tw-flex-col tw-gap-3 tw-bg-white tw-p-5">
              {{ 'screens.deceasedInformation.information.iban.tooltip' | translate }}
            </div>
          </ia-tooltip>
        </div>

        @if (deceasedInformationFacade.iban.invalid && deceasedInformationFacade.iban.dirty) {
          <p class="tw-mt-1.5 tw-font-sans tw-text-imperial-red">
            {{ 'screens.deceasedInformation.information.iban.error' | translate }}
          </p>
        }
      </div>
    </div>
  </ia-panel>

  @if (
    {
      isLoading: successionFacade.customerInformationIsLoading$ | async,
      isNext: successionFacade.isNextPageLoading$ | async,
    };
    as vm
  ) {
    <div class="tw-mt-5 tw-flex tw-justify-center sm:tw-justify-end">
      <button
        iaButton
        type="submit"
        id="btn-deceased-information-next"
        data-test-id="btn-deceased-information-next"
        variant="primary"
        [disabled]="vm.isLoading"
        [isProcessing]="!!vm.isLoading && !!vm.isNext"
      >
        {{ 'screens.deceasedInformation.buttons.buttonNext.title' | translate }}
      </button>
    </div>
  }
</form>
